import React, { useEffect } from "react";
import { Form, Button, Input, DatePicker } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormItem from "../../../../components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";


function EducationList({
    name = "education",
    label = "Education",
    dataList = [],
    minItems = 1,
    maxItems,
    addButtonClass,
    mode = "edit",
    labelExtra,
    icon: Icon,
    listClass = "list-1-column",
    applicantId,
}) {
    const form = Form.useFormInstance();

    const emptyEducation = {
        edb_id: 0,
        edb_applicant_id: applicantId || null,
        edb_school_name: "",
        edb_degree: "",
        edb_date_from: null,
        edb_date_to: null,
    };

    const initialData = dataList && dataList.length > 0
            ? dataList
            : [emptyEducation];

    useEffect(() => {
        if (form && mode !== "view") {
            const currentValues = form.getFieldValue(name);

            if (!currentValues || currentValues.length === 0) {
                form.setFieldValue(name, [emptyEducation]);
            }
        }
    }, [form, name, mode]);

    return (
        <Form.List
            name={name}
            initialValue={[initialData]}
            rules={[
                requiredField(),
                {
                    validator: async (_, value) => {
                        if (!value || value.length < minItems) {
                            return Promise.reject(
                                new Error(
                                    `At least ${minItems} education${
                                        minItems > 1 ? "s" : ""
                                    } required`
                                )
                            );
                        }

                        return Promise.resolve();
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>
                    <div className="flex items-center gap-1 mb-2">
                        {Icon && <Icon className="w-4 h-4" />}
                        <span className="text-sm">{label}</span>
                        {labelExtra}
                    </div>

                    <div className={`gap-3 mb-3 ${listClass}`}>
                        {fields.map(({ key, name: fieldName, ...restField }, index) => {

                            return (
                                <div
                                    key={key}
                                    className="border rounded-lg p-4 mb-3"
                                >
                                    <div className="flex justify-between items-center">

                                        {mode === "edit" && fields.length > minItems && (
                                            <MinusCircleOutlined
                                                className="text-gray-500 dark:text-white cursor-pointer"
                                                onClick={() => remove(fieldName)}
                                            />
                                        )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <FormItem
                                            name={[fieldName, "edb_id"]}
                                            hidden
                                        >
                                            <Input type="hidden"/>
                                        </FormItem>
                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "edb_degree"]}
                                            label="Degree"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="input-field"
                                                placeholder="Enter degree"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "edb_school_name"]}
                                            label="School Name"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="input-field"
                                                placeholder="Enter school name"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "edb_date_from"]}
                                            label="Start Date"
                                            rules={[requiredField()]}
                                        >
                                            <Input
                                                className="w-full input-field"
                                                placeholder="Enter start date"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>

                                        <FormItem
                                            {...restField}
                                            name={[fieldName, "edb_date_to"]}
                                            label="End Date"
                                        >
                                            <Input
                                                className="w-full input-field"
                                                placeholder="Enter end date"
                                                readOnly={mode !== "edit"}
                                            />
                                        </FormItem>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <Form.ErrorList errors={errors} className="mb-2 text-red-500" />

                    {mode === "edit" && (!maxItems || fields.length < maxItems) && (
                        <FormItem>
                            <Button
                                type="dashed"
                                onClick={() => add(emptyEducation)}
                                icon={<PlusOutlined />}
                                className={addButtonClass}
                            >
                                Add education
                            </Button>
                        </FormItem>
                    )}
                </>
            )}
        </Form.List>
    );
}

export default EducationList;